<template>
  <van-empty description="暂无数据" />
</template>

<script>
import { Empty } from 'vant';
export default {
  name: 'Empty',
  components: {
    [Empty.name]: Empty,
  },
};
</script>
